import moment from 'moment'
import i18n from '@/utils/lang'
export default {
  loading: false,
  lang: localStorage.getItem('lang') || 'zh',
  locale: getData('locale' || {}),
  userSession: getData('userSession', {}),
  currentShop: getData('currentShop', {}),
  exclude: null,
  pagination_setting: {
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '30', '40'],
  },
  show_time_setting: {
    hideDisabledOptions: true,
    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')],
  },
  bizModeList: JSON.parse(localStorage.getItem('bizModeList')) || {},
  /*
    CNY("CNY", "CN", "人民币"),
    USD("USD", "US", "美元"),
    JPY("JPY", "JP", "日元"),
    EUR("EUR", "EU", "欧元"),
    HKD("HKD", "HK", "港币"),
    SGD("SGD", "SG", "新加坡元"),
    AUD("AUD", "AU", "澳元"),
    GBP("GBP", "GB", "英镑"),
    CAD("CAD", "CA", "加拿大元"),
    CHF("CHF", "CH", "瑞士法郎"),
    NZD("NZD", "NZ", "新西兰元"),
    MMK("MMK", "MM", "缅甸元"),
    THB("THB", "TH", "泰铢"),
    VND("VND", "VN", "越南盾"),
    PHP("PHP", "PH", "菲律宾比索"),
    TWD("TWD", "TW", "台币");
    */
  currencyMap: [
    'CNY',
    'USD',
    'JPY',
    'EUR',
    'HKD',
    'SGD',
    'AUD',
    'GBP',
    'CAD',
    'CHF',
    'NZD',
    'MMK',
    'THB',
    'VND',
    'PHP',
    'TWD',
  ],
  // 状态列表
  purchaseStatusList: [
    'WAIT_CHECK',
    'WAIT_SUPPLIER_SEND_GOODS',
    'WAIT_INBOUND',
    'PART_INBOUND',
    'FINISH',
    'CANCEL',
  ], //采购单状态
  purchaseRequestStatusList: [
    'WAIT_CHECK',
    'WAIT_MIDDLE_CHECK',
    'WAIT_FINAL_CHECK',
    'PASS',
    'REJECT',
  ], //采购申请单状态
  transferStatusList: [
    'WAIT_CHECK',
    'WAIT_PUSH',
    'WAIT_OUTBOUND',
    'WAIT_INBOUND',
    'PART_INBOUND',
    'CANCEL',
    'FINISH',
    'PUSH_FAIL',
  ], //调拨单状态
  purchaseReturnStatusList: [
    'WAIT_CHECK',
    'WAIT_PUSH',
    'WAIT_OUTBOUND',
    'FINISH',
    'CANCEL',
    'PUSH_FAIL',
  ], //采购退货状态
  // rate: window.devicePixelRatio >= 2 ? 2.6 / window.devicePixelRatio : 1,
  rate: 1,
  goodsTypeMapping: {
    GENERAL: i18n.t('成品'),
    SEMI_FINISHED_PRODUCT: i18n.t('半成品'),
    RAW_MATERIAL: i18n.t('原料'),
    VIRTUAL: i18n.t('虚拟商品'),
    GIFT: i18n.t('赠品'),
  },
  saleTypeMapping: {
    FRESHLY_MADE_AND_SOLD: i18n.t('现制现售'),
    STOCK_UP_FOR_SALE: i18n.t('备货销售'),
    PURCHASE_SALE: i18n.t('采购销售'),
    ONLY_FOR_PRODUCTION: i18n.t('生产专用'),
  },
  currencySymbolMapping: {
    AUD: '$',
    CAD: '$',
    CNY: '￥',
    EUR: '€',
    GBP: '￡',
    HKD: 'HK$',
    JPY: '￥',
    KRW: '₩',
    MMK: 'K',
    PHP: '₱',
    SGD: 'S$',
    THB: '฿',
    TWD: 'NT$',
    USD: '$',
    VND: '₫',
  },
}

function getData(name, defaultData) {
  let data = localStorage.getItem(name)
  if (data === undefined || data === 'undefined' || data === null || data === 'null') {
    return defaultData
  }
  try {
    return JSON.parse(data)
  } catch (err) {
    console.log(err)
  }
  return data
}
